var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "模块名称：" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入模块名称" },
                        on: { clear: _vm.handerSearch },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handerSearch($event)
                          },
                        },
                        model: {
                          value: _vm.listPram.moduleName,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "moduleName", $$v)
                          },
                          expression: "listPram.moduleName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "enabled", $$v)
                            },
                            expression: "listPram.enabled",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: null },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "启用", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "禁用", value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "未设置负责人：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.notSetType,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "notSetType", $$v)
                            },
                            expression: "listPram.notSetType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: null },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未设置开发", value: "dev" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未设置测试", value: "test" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未设置任何负责人", value: "all" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "开发：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择开发" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.devUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "devUserId", $$v)
                            },
                            expression: "listPram.devUserId",
                          },
                        },
                        _vm._l(_vm.adminList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.realName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "测试：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择测试" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.testUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "testUserId", $$v)
                            },
                            expression: "listPram.testUserId",
                          },
                        },
                        _vm._l(_vm.adminList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.realName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:system:alert:module:list"],
                              expression: "['admin:system:alert:module:list']",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.handerSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary", plain: "" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb10" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:system:alert:module:create"],
                      expression: "['admin:system:alert:module:create']",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handlerAdd },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v(" 新增模块\n\t\t\t"),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "moduleKey",
                  label: "模块code",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "moduleName",
                  label: "模块名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "packagePrefix",
                  label: "包路径",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "impactScope",
                  label: "影响范围",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "开发", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              multiple: "",
                              placeholder: "请选择开发",
                              size: "mini",
                            },
                            on: {
                              "visible-change": function (visible) {
                                return _vm.handleDropdownClose(
                                  scope.row,
                                  "dev",
                                  visible
                                )
                              },
                            },
                            model: {
                              value: scope.row.devUserIdsArray,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "devUserIdsArray", $$v)
                              },
                              expression: "scope.row.devUserIdsArray",
                            },
                          },
                          _vm._l(_vm.adminList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.realName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "测试", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              multiple: "",
                              placeholder: "请选择测试",
                              size: "mini",
                            },
                            on: {
                              "visible-change": function (visible) {
                                return _vm.handleDropdownClose(
                                  scope.row,
                                  "test",
                                  visible
                                )
                              },
                            },
                            model: {
                              value: scope.row.testUserIdsArray,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "testUserIdsArray", $$v)
                              },
                              expression: "scope.row.testUserIdsArray",
                            },
                          },
                          _vm._l(_vm.adminList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.realName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                            "inactive-text": "禁用",
                            disabled: !_vm.checkPermi([
                              "admin:system:alert:module:status",
                            ]),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onStatusChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.enabled,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "enabled", $$v)
                            },
                            expression: "scope.row.enabled",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updatedAt",
                  label: "更新时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "120",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:system:alert:module:update"],
                                expression:
                                  "['admin:system:alert:module:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditAlertModule", {
        ref: "editRef",
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }